import { CHANGE_ACTIVE_PAGE, ANSWER_QUESTION, CHANGE_ACTIVE_QUESTION, CHANGE_COUNT_TIMER, EXAM_INFO} from './examType';
import _ from 'lodash';

const initialState = {
    activePage: 1,
    questions: [],
    exam: {},
    answers: [],
    result_exam:{
        total_answer: 0,
        total_true: 0,
        total_false: 0,
        index_question_active: 0,
        countTimer: "00:00",
    }
};

export default function exam(state = initialState, action) {
    switch (action.type) {
        case EXAM_INFO:
            {
                return { ...state, questions: action.data.questions, exam: action.data.exam }
            }
        case CHANGE_ACTIVE_PAGE:
            {
                let activePage = action.id;
                return { ...state, activePage: activePage }
            }
        case CHANGE_COUNT_TIMER:
            {
                let countTimer = action.countTimer;
                return { ...state, countTimer: countTimer }
            }
        case ANSWER_QUESTION:
            {
                let answers = state.answers;
                let itemAnsewers = answers.find(item => {
                    return item.id_question === action.answer.id_question
                })
                if (itemAnsewers) {
                    itemAnsewers.option = action.answer.option;
                }
                else {
                    answers.push(action.answer);
                }
                return { ...state, answers: answers }
            }
        case CHANGE_ACTIVE_QUESTION:
            {
                let k = 0;
                if (action.id <= 0) {
                    k = 0
                }
                else if (action.id >= state.questions.length - 1) {
                    k = state.questions.length - 1
                }
                else {
                    k = action.id
                }
                return { ...state, activeQuestion: k }
                // return state
            }

        default:
            return state;
    }
}
